import { Helmet } from "react-helmet-async";
import ReactHeader from "./reactHeader";
import FooterSection from "./footerSection";
import AnimatedBlock from "./animatedBlock";
import "./argusExportGuide.css";

const steps = [
  {
    index: "01",
    title: "Navigate to the Report",
    body: (
      <>
        Under{" "}
        <strong>Audit Reports</strong>, click <strong>Input Assumptions</strong>.
      </>
    ),
    image: "/argus-guide-step1.png",
    alt: "ARGUS Enterprise Report Dock with Audit Reports and Input Assumptions highlighted",
  },
  {
    index: "02",
    title: "Export to Excel",
    body: (
      <>
        From the Report ribbon, click <strong>Export</strong>, then choose{" "}
        <strong>Microsoft Excel (XLSX)</strong>.
        <span className="aeg-step-note">
          A Report Package can also be exported, as long as it includes the
          Input Assumptions report.
        </span>
      </>
    ),
    image: "/argus-guide-step2.png",
    alt: "ARGUS Enterprise Export menu with Microsoft Excel (XLSX) highlighted",
  },
  {
    index: "03",
    title: "Share the file",
    body: (
      <>
        Share the exported .xlsx file.
      </>
    ),
    image: "/argus-guide-step3.png",
    alt: "Exported Input Assumptions report open in Excel",
  },
];

const ArgusExportGuideSection = () => (
  <section className="aeg-section">
    <div className="aeg-container">
      <AnimatedBlock>
        <p className="is-eyebrow">ARGUS File Request</p>
        <h1 className="is-headline">How to Export the ARGUS Input Assumptions Report</h1>
        <p className="is-subtext">
        </p>
      </AnimatedBlock>

      <div className="aeg-steps-list">
        {steps.map((s) => (
          <AnimatedBlock key={s.index}>
            <div className="aeg-step-row">
              <div className="aeg-step-text">
                <span className="feature-index">{s.index}</span>
                <h3 className="feature-title">{s.title}</h3>
                <p className="feature-body">{s.body}</p>
              </div>
              <div className="aeg-step-image-wrap">
                <img
                  src={s.image}
                  alt={s.alt}
                  className="aeg-step-image"
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </div>
          </AnimatedBlock>
        ))}
      </div>
    </div>
  </section>
);

const ArgusExportGuide = () => (
  <div className="App">
    <Helmet>
      <title>How to Export Your ARGUS Input Assumptions Report | Khor Developer</title>
      <meta name="robots" content="noindex, follow" />
      <meta
        name="description"
        content="Step-by-step instructions for exporting the Input Assumptions report from ARGUS Enterprise and sending it to Khor Developer."
      />
      <meta property="og:title" content="How to Export Your ARGUS Input Assumptions Report | Khor Developer" />
      <meta property="og:url" content="https://www.khordeveloper.com/argus-export-guide" />
      <link rel="canonical" href="https://www.khordeveloper.com/argus-export-guide" />
    </Helmet>
    <ReactHeader />
    <ArgusExportGuideSection />
    <FooterSection />
  </div>
);

export default ArgusExportGuide;
